export default __webpack_public_path__ + "static/media/ARcabin.84657bb9.gif";